import React from "react";
import { Link } from "react-router-dom";
import { FaSignInAlt, FaUserPlus } from "react-icons/fa";

const AuthModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="card-board p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <h2 className="heading-display text-2xl mb-2">
            Create Your Tournament
          </h2>
          <p className="text-brand-muted">
            Sign in to start managing your bowling tournaments with our powerful
            platform.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/signin"
            state={{ from: "/create-tournament" }}
            className="w-full flex items-center justify-center px-4 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-cream bg-brand-charcoal hover:bg-brand-charcoal/90"
            onClick={onClose}
          >
            <FaSignInAlt className="mr-2" />
            Sign In
          </Link>

          <Link
            to="/signup"
            state={{ from: "/create-tournament" }}
            className="w-full flex items-center justify-center px-4 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-charcoal"
            onClick={onClose}
          >
            <FaUserPlus className="mr-2" />
            Create Account
          </Link>
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={onClose}
            className="text-brand-muted hover:text-brand-charcoal text-sm"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
